import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles, Icon, Link, Markdown, useTheme } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';

import styles from './styles';

const useStyles = createUseStyles(styles, 'CopilotDisclaimer');

const CopilotDisclaimer = memo(({ className, content }) => {
    const classes = useStyles();
    const theme = useTheme();
    const { t } = useWeb5Context();
    const defaultContent = useMemo(() => t('label_copilot_legal_response_disclaimer'), [t]);

    const markdownProps = useMemo(
        () => ({
            className: classNames(classes.root, className),
            components: {
                a: ({ children, href }) => (
                    <Link
                        className={classes.link}
                        href={href}
                        target="_blank"
                        type="caption"
                        variation="primary"
                    >
                        {children}
                        <Icon color={theme.colors.actionMajor[500]} name="launch" />
                    </Link>
                ),
            },
            content: content || defaultContent,
            overrides: {
                p: {
                    color: theme.colors.textLight.secondary,
                    type: 'caption',
                },
            },
        }),
        [
            className,
            classes.link,
            classes.root,
            content,
            defaultContent,
            theme.colors.actionMajor,
            theme.colors.textLight.secondary,
        ],
    );

    return <Markdown {...markdownProps} />;
});

CopilotDisclaimer.displayName = 'CopilotDisclaimer';

CopilotDisclaimer.propTypes = {
    content: PropTypes.string,
};

export default CopilotDisclaimer;
